import { useEffect } from "react";
import { useMode } from "@/lib/mode";

/**
 * App-wide keyboard shortcuts.
 *  - "P" — toggle presentation/explore
 *  - "Esc" — exit presentation (when inside it)
 *
 * Mounted once at the App root so it stays bound regardless of route.
 */
export const GlobalShortcuts = () => {
  const { mode, toggleMode, exitPresent } = useMode();

  useEffect(() => {
    const handler = (e) => {
      const tag = (e.target?.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea" || e.target?.isContentEditable) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;

      if ((e.key === "p" || e.key === "P")) {
        e.preventDefault();
        toggleMode();
      } else if (e.key === "Escape" && mode === "present") {
        e.preventDefault();
        exitPresent();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [mode, toggleMode, exitPresent]);

  return null;
};

export default GlobalShortcuts;
